import React from 'react'
import { useEffect } from 'react';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import Star from './Star';
import { OWNER_NOVA, TESTMONIAL1, NOVA_DES, TESTMONIAL2, OWNER_TRENDY, TRENDY_DES, TESTMONIAL3, OWNER_AMIR, AMIR_DES, OWNER_SONIA, TESTMONIAL4, SONIA_DES, TESTMONIAL5, OWNER_VIKRAM, VIKRAM_DES } from '../constant/constant';



const Testimonial = () => {
    useEffect(() => {
        var swiper = new Swiper(".mySwiper", {
            slidesPerView: 5,
            spaceBetween: 28,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: "#slider-button-right",
                prevEl: "#slider-button-left",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    centeredSlides: false,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 28,
                    centeredSlides: true,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        });

        document.getElementById('slider-button-left').addEventListener('click', () => {
            swiper.slidePrev();
        });

        document.getElementById('slider-button-right').addEventListener('click', () => {
            swiper.slideNext();
        });
    });
    return (
        <>
            <section className="clear-both py-10 bg-gray-100">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="mb-14 flex flex-col justify-center items-center sm:flex-row sm:items-center sm:justify-between max-sm:gap-8">
                        <h2 className="text-4xl text-center font-bold text-gray-900 lg:text-left">Testimonials </h2>
                        <div className="flex items-center gap-8">
                            <button id="slider-button-left"
                                className="swiper-button-prev group flex justify-center items-center border border-solid border-indigo-600 w-12 h-12 transition-all duration-500 rounded-full hover:bg-indigo-600 "
                                data-carousel-prev>
                                <svg className="h-6 w-6 text-indigo-600 group-hover:text-white" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20.9999 12L4.99992 12M9.99992 6L4.70703 11.2929C4.3737 11.6262 4.20703 11.7929 4.20703 12C4.20703 12.2071 4.3737 12.3738 4.70703 12.7071L9.99992 18"
                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" />
                                </svg>

                            </button>
                            <button id="slider-button-right"
                                className="swiper-button-next group flex justify-center items-center border border-solid border-indigo-600 w-12 h-12 transition-all duration-500 rounded-full hover:bg-indigo-600"
                                data-carousel-next>
                                <svg className="h-6 w-6 text-indigo-600 group-hover:text-white" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3 12L19 12M14 18L19.2929 12.7071C19.6262 12.3738 19.7929 12.2071 19.7929 12C19.7929 11.7929 19.6262 11.6262 19.2929 11.2929L14 6"
                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round" />
                                </svg>

                            </button>
                        </div>
                    </div>

                    <div className="lg:flex grid grid-cols-1 md:grid-cols-2 justify-center items-center gap-8 swiper mySwiper">
                        <div className="swiper-wrapper">
                            <div
                                className="swiper-slide group bg-white border border-solid h-auto border-gray-300 rounded-2xl p-6 transition-all duration-500 w-full hover:border-indigo-600 slide-active:border-indigo-600">
                                <Star />
                                <p className="text-gray-500 lg:h-24 h-auto transition-all duration-500 mb-9 group-hover:text-gray-800">{TESTMONIAL1}</p>
                                <div className="flex items-center gap-5">
                                    <div className="grid gap-1">
                                        <h5
                                            className="text-gray-900 font-medium transition-all duration-500  group-hover:text-indigo-600 swiper-slide-active:text-indigo-600">
                                            {OWNER_NOVA}</h5>
                                        <span className="text-sm leading-6 text-gray-500">{NOVA_DES}</span>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="swiper-slide group bg-white border border-solid border-gray-300 rounded-2xl p-6 transition-all duration-500 w-full hover:border-indigo-600 slide-active:border-indigo-600">
                                <Star />
                                <p
                                    className="text-gray-500 lg:h-24 h-auto transition-all duration-500 mb-9  group-hover:text-gray-800">
                                    {TESTMONIAL2}
                                </p>
                                <div className="flex items-center gap-5">
                                    <div className="grid gap-1">
                                        <h5
                                            className="text-gray-900 font-medium transition-all duration-500  group-hover:text-indigo-600 swiper-slide-active:text-indigo-600">
                                            {OWNER_TRENDY}</h5>
                                        <span className="text-sm leading-6 text-gray-500">{TRENDY_DES}</span>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="swiper-slide group bg-white border border-solid border-gray-300 rounded-2xl p-6 transition-all duration-500 w-full hover:border-indigo-600 ">
                                <Star />
                                <p
                                    className="text-gray-500 lg:h-24 h-auto transition-all duration-500 mb-9 group-hover:text-gray-800 ">
                                    {TESTMONIAL3}
                                </p>
                                <div className="flex items-center gap-5">
                                    <div className="grid gap-1">
                                        <h5
                                            className="text-gray-900 font-medium transition-all duration-500 group-hover:text-indigo-600 swiper-slide-active:text-indigo-600">
                                            {OWNER_AMIR}</h5>
                                        <span className="text-sm leading-6 text-gray-500">{AMIR_DES}</span>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="swiper-slide group bg-white border border-solid border-gray-300 rounded-2xl p-6 transition-all duration-500 w-full hover:border-indigo-600 slide-active:border-indigo-600">
                                <Star />
                                <p
                                    className="text-gray-500 lg:h-24 h-auto transition-all duration-500 mb-9 group-hover:text-gray-800">
                                    {TESTMONIAL4}
                                </p>
                                <div className="flex items-center gap-5">
                                    <div className="grid gap-1">
                                        <h5
                                            className="text-gray-900 font-medium transition-all duration-500  group-hover:text-indigo-600 swiper-slide-active:text-indigo-600">
                                            {OWNER_SONIA}</h5>
                                        <span className="text-sm leading-6 text-gray-500">{SONIA_DES} </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="swiper-slide group bg-white border border-solid border-gray-300 rounded-2xl p-6 transition-all duration-500 w-full hover:border-indigo-600 ">
                                <Star />
                                <p
                                    className="text-gray-500 lg:h-24 h-auto transition-all duration-500 mb-9  group-hover:text-gray-800">
                                    {TESTMONIAL5}
                                </p>
                                <div className="flex items-center gap-5">
                                    <div className="grid gap-1">
                                        <h5
                                            className="text-gray-900 font-medium transition-all duration-500  group-hover:text-indigo-600 swiper-slide-active:text-indigo-600">
                                            {OWNER_VIKRAM}</h5>
                                        <span className="text-sm leading-6 text-gray-500">{VIKRAM_DES}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Testimonial